import { KyInstance } from 'ky';

import { LotTrackingQueryParams, LotTrackingResponse } from '@/types/fulfill/batches';
import { buildSearchParams, handleRequest } from '@/utils/httpUtils';

export interface IReqLotTracking {
  getLots: (params: LotTrackingQueryParams) => Promise<LotTrackingResponse>;
  downloadLotsReport: (params: LotTrackingQueryParams) => Promise<{ file_url: string }>;
}

export function reqLotTracking(http: KyInstance): IReqLotTracking {
  const route = 'api/v1';
  return {
    getLots: (params) =>
      handleRequest<LotTrackingResponse>(http, 'get', `${route}/lot-tracking`, {
        searchParams: buildSearchParams(params),
      }),
    downloadLotsReport: (params) =>
      handleRequest<{ file_url: string }>(http, 'get', `${route}/downloads/batches/csv`, {
        searchParams: buildSearchParams({ ...(params ?? {}), _t: Date.now() }),
        cache: 'no-store',
      }),
  };
}
